import apiSlice from "./apiSlice";

const pmDashboardSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProgressKpi: builder.query({
            query: ({ projectId }) => ({
                url: `p-and-m/progress-kpi`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["ProgressKpi"],
        }),

        getUtilizationKpi: builder.query({
            query:({projectId}) => ({
                url:`pnmdata/utilization-kpis`,
                params: {projectId},
            })

        }),

        getOwnedHiredKpi: builder.query({
            query: ({ projectId }) => ({
                url: `p-and-m/owned-hired-kpi`,
                params: { projectId },
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["OwnedHiredKpi"],
        }),

        getMachinStatus : builder.query({
            query:({projectId}) => ({
                url:`pnmdata/machine-status-category`,
                params: { projectId }

            })
        }),
         getMachineRunHours : builder.query({
            query:({projectId}) => ({
                url:`pnmdata/machine-run-hours`,
                params: { projectId }

            })
        }),

        getPMData: builder.query({
            query: (params) => ({
                url: `p-and-m`,
                params,
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["PMData"],
        }),
    }),
});

export const {
    useGetProgressKpiQuery,
    useGetOwnedHiredKpiQuery,
    useGetPMDataQuery,
    useGetUtilizationKpiQuery,
    useGetMachinStatusQuery,
    useGetMachineRunHoursQuery
} = pmDashboardSlice;

export default pmDashboardSlice;
